<template>
	<div class="stockist">
		<div class="container">
			<div class="row">
				<div class="col-12 p-md-0">
					<div class="col-12 pt-3 pb-3 p-md-3 rounded background-white top-slider shadow align-items-center mb-5">
						<div class="col-12 p-0 d-md-flex" v-if="Object.keys(stockistOne).length == 0">
							<div class="offset-1 col-10 justify-content-center offset-md-0 col-md-4 pt-3 pb-3">
								<vcl :width="300" :height="300" :speed="2" primaryColor="#f3f3f3" secondaryColor="#ecebeb" >
									<rect x="0" y="2" rx="10" ry="10" width="300" height="300" />
								</vcl>
							</div>
							<div class="col-12 col-md-8 p-0 p-md-3 font-size-sm-10 mt-md-3 text-center text-md-left">
								<div class="col-12 font-size-20 font-size-sm-13 color-mila font-weight-bold pt-2 f-lato">
									<vcl :width="300" :height="130" :speed="2" primaryColor="#f3f3f3" secondaryColor="#ecebeb" >
										<rect x="0" y="0" rx="5" ry="5" width="100" height="20" />
										<rect x="0" y="30" rx="5" ry="5" width="130" height="20" />
										<rect x="0" y="60" rx="5" ry="5" width="160" height="15" />
										<rect x="0" y="85" rx="5" ry="5" width="80" height="15" />
									</vcl>
								</div>
							</div>
						</div>
						<div class="col-12 p-0 d-md-flex" v-else>
							<div class="offset-1 col-10 justify-content-center offset-md-0 col-md-4 pt-3 pb-3" v-viewer="{movable: false, toolbar: false, fullscreen: true, toolbar: false, title:false}">
								<img class="stockist-image cursor-pointer" alt="stockist" :src="stockistOne.stockist_image">
							</div>
							<div class="col-12 col-md-8 p-0 p-md-3 font-size-sm-10 mt-md-3 text-center text-md-left">
								<div class="col-12 font-size-20 font-size-sm-13 color-mila font-weight-bold pt-2 f-lato">
									{{stockistOne.stockist_code}}
								</div>
								<div class="col-12 font-size-20 font-size-sm-13 color-purple pt-1">
									{{stockistOne.stockist_name}}
								</div>
								<div class="col-12 mt-2 mt-md-3 pt-1" v-if="stockistOne.stockist_origin_city_name && stockistOne.stockist_origin_province_name">
									<span class="background-gray-dark no-box-shadow rounded font-size-12 font-size-sm-10 color-white p-2 pl-3 pr-3" id="lokasi-stockist">
										<font-awesome-icon :icon="['fas', 'map-marker-alt']" class="mr-2"/>
										{{stockistOne.stockist_origin_city_name}}, {{stockistOne.stockist_origin_province_name}}
									</span>
								</div>
								<!-- <div class="col-12 d-flex pt-4 justify-content-center justify-content-md-start">
									<div class="p-0 font-size-14 font-size-sm-10">
										<font-awesome-icon :icon="['fas', 'star']" class="mr-1 color-star-full"/>
										<font-awesome-icon :icon="['fas', 'star']" class="mr-1 color-star-full"/>
										<font-awesome-icon :icon="['fas', 'star']" class="mr-1 color-star-full"/>
										<font-awesome-icon :icon="['fas', 'star']" class="mr-1 color-star-full"/>
										<font-awesome-icon :icon="['fas', 'star']" class="mr-1 color-star-empty"/>
									</div>
									<div class="p-0 font-size-12 font-size-sm-9 pl-1 pl-md-3">
										(<span id="jumlah-ulasan">0</span> Ulasan)
									</div>
								</div> -->
								<div class="col-12 mt-2 mt-md-3 font-size-11 font-size-sm-8 color-gray">
									Penjualan Terakhir 
									<span class="color-black font-size-13 font-size-sm-9 f-lato" id="tanggal-terakhir-stockist">{{(stockistOne.stockist_order_count > 0 ? stockistOne.last_trx_datetime : '') | hariTanggalJam}}</span>
								</div>
								<div class="col-12 mt-1 mt-md-3 font-size-11 font-size-sm-8 color-gray">
									<span class="color-black font-size-16 font-size-sm-11 f-lato" id="terjual-stockist">{{(stockistOne.stockist_order_count > 0 ? stockistOne.stockist_order_count : '0') | toNumber}}</span> Produk Terjual
								</div>
							</div>
						</div>
						<div class="col-12 text-center color-black font-size-22 font-size-sm-15 font-weight-bold pt-5 pb-md-3 text-uppercase">
							Produk tersedia
						</div>
						<div class="col-12 pl-0 pr-0 pb-4 d-flex flex-wrap" v-if="Object.keys(stockistOne).length == 0">
							<div class="col-12 col-md-6 pt-3 pl-2 pr-2 pl-md-3 pr-md-3" v-for="index in 2" :key="index">
								<div class="col-12 p-0 product">
									<div class="col-12 background-white rounded cus-box-shadow pt-3 pb-3 mb-2">
										<div class="col-12 d-md-flex pl-0 pr-0">
											<div class="col-12 col-md-6 pl-0 pr-0 pr-md-3">
												<vcl :width="300" :height="300" :speed="2" primaryColor="#f3f3f3" secondaryColor="#ecebeb" >
													<rect x="0" y="2" rx="10" ry="10" width="300" height="300" />
												</vcl>
											</div>
											<div class="col-12 col-md-6 pl-0 pr-0 pt-2 pt-md-0">
												<vcl :width="300" :height="270" :speed="2" primaryColor="#f3f3f3" secondaryColor="#ecebeb" >
													<rect x="0" y="0" rx="10" ry="10" width="270" height="30" />
													<rect x="0" y="40" rx="10" ry="10" width="180" height="30" />
													<rect x="0" y="80" rx="10" ry="10" width="70" height="25" />
													<rect x="0" y="115" rx="10" ry="10" width="80" height="20" />
													<rect x="80" y="115" rx="10" ry="10" width="20" height="20" />
													<rect x="110" y="115" rx="10" ry="10" width="100" height="20" />
													<rect x="220" y="115" rx="10" ry="10" width="80" height="20" />
													<rect x="0" y="145" rx="10" ry="10" width="120" height="20" />
													<rect x="120" y="145" rx="10" ry="10" width="20" height="20" />
													<rect x="150" y="145" rx="10" ry="10" width="90" height="20" />
													<rect x="250" y="145" rx="10" ry="10" width="50" height="20" />
													<rect x="0" y="175" rx="10" ry="10" width="80" height="20" />
													<rect x="80" y="175" rx="10" ry="10" width="20" height="20" />
													<rect x="110" y="175" rx="10" ry="10" width="100" height="20" />
													<rect x="220" y="175" rx="10" ry="10" width="80" height="20" />
													<rect x="0" y="205" rx="10" ry="10" width="120" height="20" />
													<rect x="120" y="205" rx="10" ry="10" width="20" height="20" />
													<rect x="150" y="205" rx="10" ry="10" width="90" height="20" />
													<rect x="250" y="205" rx="10" ry="10" width="50" height="20" />
													<rect x="0" y="235" rx="10" ry="10" width="80" height="20" />
													<rect x="80" y="235" rx="10" ry="10" width="20" height="20" />
													<rect x="110" y="235" rx="10" ry="10" width="100" height="20" />
													<rect x="220" y="235" rx="10" ry="10" width="80" height="20" />
												</vcl>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 pl-0 pr-0 pb-4 d-flex flex-wrap" v-else>
							<div class="col-12 col-md-6 pt-3 pl-2 pr-2 pl-md-3 pr-md-3" v-for="(product,index) in stockistOne.product" :key="index">
								<div class="col-12 p-0 product">
									<div class="col-12 p-0 product-hover position-absolute">
										<div class="col-12 p-0 text-center">
											<div class="col-12 color-mila text-center pb-2">
												<div class="font-size-15" v-if="product.stock_store > 0">Stok {{product.stock_store >= 25 ? 'Tersedia' : 'Terbatas'}}</div>
												<div class="font-size-15 color-red" v-else>Habis</div>
											</div>
											<button class="col-12 col-md-8 col-lg-5 btn background-button-template color-white box-purple" @click="masukKeranjang(product)">
												<div class="pt-1 pb-1 font-size-10"><i class="fas fa-shopping-cart mr-2"></i>
												Masukkan Keranjang</div>
											</button>
										</div>
									</div>
									<div class="col-12 product-no-hover background-white rounded cus-box-shadow pt-3 pb-3 mb-2">
										<div class="col-12 d-md-flex flex-wrap pl-0 pr-0">
											<div class="col-8 col-lg-5 pl-0 pr-0 pr-md-3 ml-auto mr-auto">
												<img :src="product.product_image_filename" class="img-fluid rounded" alt="">
											</div>
											<div class="col-12 col-lg-7 pl-0 pr-0 pt-2 pt-md-3 pt-lg-0">
												<div class="color-mila font-weight-bold font-size-14 font-size-sm-12">{{ product.product_name }}</div>
												<div class="color-purple font-size-13 font-size-sm-11 f-lato">Rp {{ product.product_price | toNumber }} / {{ product.product_unit }}</div>
												<div class="color-gray font-size-11 font-size-sm-9 f-lato">{{product.product_weight | toKg}}</div>
												<div class="color-black font-size-11 font-size-sm-9 pt-3">{{ product.product_description.slice(0, 150) }}...</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<VModal ref="modalKeranjang" class="modal-sm-90vh">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<div class="col-12 pt-2 pt-md-4 pb-4 d-md-flex">
					<div class="col-12 col-md-4 pl-0 pr-0 pr-md-3">
						<img :src="selectedProduct.product_image_filename" alt="" class="w-100">
						<div class="col-12 position-absolute z-index-1 pl-0 pr-0 pr-md-3 bottom-0">
							<div class="col-12 background-gray-dark text-center color-white rounded pt-2 pb-2">
								<div class="" v-if="selectedProduct.stock_store > 0">Stok {{selectedProduct.stock_store >= 25 ? 'Tersedia' : 'Terbatas'}}</div>
								<div class="" v-else>Habis</div>
							</div>
						</div>
					</div>
					<div class="col-12 col-md-8 pl-0 pl-md-3 pr-0 pr-md-3 pt-3 pt-md-0">
						<div class="color-mila font-size-16 font-size-sm-13 font-weight-bold">{{selectedProduct.product_name}}</div>
						<div class="color-purple font-size-14 font-size-sm-11 pt-1 pt-md-2 f-lato">Rp {{selectedProduct.product_price | toNumber}} / {{selectedProduct.product_unit }}</div>
						<div class="color-black font-size-13 font-size-sm-11 pt-1 pt-md-2 f-lato">{{selectedProduct.product_weight | toKg}}</div>
						<div class="col-12 d-flex pt-2 pt-md-3 pl-0">
							<div class="col-4 col-md-2 color-black font-size-13 pt-1 pl-0">Jumlah</div>
							<div class="col-8 col-md-5 input-group mb-3">
								<div class="input-group-prepend" id="down">
									<button class="btn background-purple color-white" @click="qty_product--" :disabled="qty_product <= 1">
										<span class="font-size-8"><i class="fas fa-minus"></i></span>
									</button>
								</div>
								<input @keypress="onlyNumber" type="text" v-model="qty_product" class="form-control text-center no-box-shadow font-size-12 font-size-sm-10 number box-purple" aria-label="Amount" id="jumlahValue" placeholder="0" value="1">
								<!-- <ml-alert v-if="" v-for="alert in this.alerts" :key="alert.id" :type="alert.type" :message="alert.message" @close="removeAlert(alert.id)" close/> -->
								<div class="input-group-append" id="up">
									<button class="btn background-purple color-white" @click="qty_product++">
										<span class="font-size-8"><i class="fas fa-plus"></i></span>
									</button>
								</div>
								<Alert empty :content="alerts"/>
							</div>
						</div>
						<div class="col-12 pl-0 pr-0 d-md-flex pt-2 pt-md-3">
							<div class="col-12 col-md-4 pl-0 pr-0 pr-md-3">
								<button class="col-12 btn btn-outline-danger rounded pt-2 pb-2 text-capitalize" @click="modalHide">
									<i class="fa fa-times mr-3"></i>
									<span class="font-size-11">Batal</span>
								</button>
							</div>
							<div class="col-12 col-md-6 pr-0 pt-2 pt-md-0 pl-0 pl-md-3 pr-0 pr-md-3">
								<button class="col-12 btn background-button-template rounded pt-2 pb-2 color-white text-capitalize box-purple" @click="insertCart">
									<i class="fas fa-shopping-cart mr-3"></i>
									<span class="font-size-11">Masukkan Keranjang</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div></div>
			</template>
		</VModal>
		<VModal ref="modalBerhasilDitambah" class="modal-big" modalHigh>
			<template v-slot:header>
				<div class="modal-header justify-content-center">
					<h5 class="modal-title text-uppercase">Produk Berhasil Ditambahkan</h5>
					<button class="btn btn-no-box"> <img src="../../assets/modal_x.svg" class="close-modal ml-2 mt-n1" @click="() => $refs.modalBerhasilDitambah.modalHide()"></button>
				</div>
			</template>
			<template v-slot:body>
				<CartSuccess @masukKeranjang="masukKeranjang" from="stockist" :addedProduct="selectedProduct" :recommend="stockistOne.product.filter(el=> el.product_code != selectedProduct.product_code)"/>
			</template>
			<template v-slot:footer>
				<div></div>
			</template>
		</VModal>
		<VModal ref="modalKonfirmasiKeranjang" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<div slot="body" class="col-12 mb-3">
				<div class="col-12 d-md-flex pl-0 pr-0" v-if="cart">
					<div class="col-5 m-auto pt-md-3 pl-0 pl-md-3 pr-md-3 pr-0 text-center">
						<img class="img-fluid" src="/assets/icon/surprise-woman.svg">
					</div>
					<div class="col-12 col-md-7 pt-3 color-black m-auto text-md-left text-center pl-0 pr-0 pl-md-3">
						<div class="font-size-sm-11 pt-2">Yakin ingin merubah pemesanan dari <b>{{cart[0].stockist_name}}</b> ke <b>{{stockistOne.stockist_name}}</b>? Pemesanan yang Anda pilih sebelumnya akan terhapus otomatis</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<div class="modal-footer justify-content-center justify-content-md-end">
					<button class="col-6 col-md-3 btn btn-outline-danger rounded mr-1 font-size-sm-9 pr-md-4 pl-md-4 text-capitalize box-purple" type="button" @click="$refs.modalKonfirmasiKeranjang.modalHide()">
						<i class="fa fa-times mr-1"></i>Batal
					</button>
					<button class="col-6 col-md-3 btn background-button-template color-white rounded font-size-sm-9 pr-md-4 pl-md-4 text-capitalize" type="button" @click="konfirmasiKeranjang">
						<i class="fa fa-check mr-1"></i>Ya
					</button>
				</div>
			</div>
		</VModal>
	</div>
</template>

<script>
import VModal from '@/components/VModal';
import Alert from '@/components/Alert';
import CartSuccess from '@/components/AddCartSuccess';
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
	name:"Stockist",
	components:{
		VModal, Alert, CartSuccess
	},
	data() {
		return {
			selectedProduct: {},
			qty_product: 1,
			temp: '',
		}
	},
	computed: {
		...mapState('stockist', ['stockistOne']),
		...mapState('cart', ['alerts', 'cart'])
	},
	methods: {
		...mapActions('stockist', ['getStockistDetail']),
		...mapActions('cart', ['saveCart']),
		...mapMutations('cart', ['clearData', 'reset', 'resetAlert', 'setAlert']),

		scrollToTop() {
			window.scrollTo(0,0);
		},
		masukKeranjang(product) {
			this.resetAlert();
			this.qty_product = 1
			this.selectedProduct = product
			this.$refs.modalKeranjang.modalShow()
			if (this.$refs.modalBerhasilDitambah.showModal) {
				this.$refs.modalBerhasilDitambah.modalHide()
			}
		},
		konfirmasiKeranjang() {
			this.$refs.modalKonfirmasiKeranjang.modalHide()
			this.addCart(this.temp)
		},
		insertCart() {
			this.selectedProduct['quantity'] = this.qty_product
			this.selectedProduct['message'] = ''
			this.temp = {
				stockist_code : this.stockistOne.stockist_code,
				stockist_id : this.stockistOne.stockist_network_id,
				stockist_name : this.stockistOne.stockist_name,
				stockist_prov : this.stockistOne.stockist_origin_province_name,
				stockist_city : this.stockistOne.stockist_origin_city_name,
				products : this.selectedProduct
			}
			if (this.cart) {
				let indexStockist = this.cart.findIndex(x => x.stockist_code == this.stockistOne.stockist_code)
				if (indexStockist < 0) {
					if (parseInt(this.temp.products.stock_store) < parseInt(this.temp.products.quantity)) {
						let alert = 'Stok tersedia ' + this.temp.products.stock_store;
						this.setAlert(alert)
					} else {
						this.$refs.modalKeranjang.modalHide()
						this.$refs.modalKonfirmasiKeranjang.modalShow()
					}
				} else {
					this.addCart(this.temp)
				}
			} else {
				this.addCart(this.temp)
			}
		},
		addCart(temp) {
			this.saveCart(temp).then(()=>{
				if(!this.alerts) {
					this.$refs.modalKeranjang.modalHide()
					this.$refs.modalBerhasilDitambah.modalShow()
				}
			})
		},
		modalHide() {
			this.$refs.modalKeranjang.modalHide()
		},
	},
	created() {
		this.getStockistDetail(this.$route.params.code);
	},
	mounted() {
		window.scrollTo(0, 0);
		/* this.clearData() */
	},
	beforeDestroy() {
		this.reset()
	},
	filters: {
		truncate: function (text, length, suffix) {
			return text.substring(0, length) + suffix;
		},
	},
	async beforeRouteLeave(to, from, next) {
		await this.$refs.modalBerhasilDitambah.modalHide()
		await next()
	}
}
</script>

<style>
@media (min-width: 768px) {
	.recommend-descript {
		min-height: 11.5rem;
		max-height: 11.5rem;
		overflow: hidden;
	}
}
</style>